import { render, staticRenderFns } from "./AssessmentConfig.vue?vue&type=template&id=d3c1fb5a"
import script from "./AssessmentConfig.vue?vue&type=script&lang=js"
export * from "./AssessmentConfig.vue?vue&type=script&lang=js"
import style0 from "./AssessmentConfig.vue?vue&type=style&index=0&id=d3c1fb5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports